const keyOf = part => part.timesheet_id && (part.line_id || (part.source_details || {}).line_id)
    ? `${Number(part.timesheet_id)}:${Number(part.line_id || part.source_details.line_id)}` : null;
const unitOf = part => part.basis === 'hourly' ? 'accepted_minutes' : 'accepted_days';
const legacy = line => ['accepted_days', 'accepted_minutes'].some(key => Object.prototype.hasOwnProperty.call(line.manual_overrides || {}, key));
const effective = (line, part) => ((line.source_calculation || {}).components || []).find(row => row.source_key && row.source_key === keyOf(part)) || {
    ...part, source_key: keyOf(part), quantity_unit: unitOf(part), accepted_quantity: Number(part[unitOf(part)] || 0),
    original_quantity: Number(part[unitOf(part)] || 0), effective_amount_minor: Number(part.amount_minor || 0), quantity_changed: false};

function minutesText(value) {
    const minutes = Number(value || 0);
    return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
}
function parseQuantity(text, unit) {
    const value = String(text).trim().replace(',', '.');
    if (unit === 'accepted_minutes') {
        if (/^\d+:([0-5]\d)$/.test(value)) {
            const [hours, minutes] = value.split(':').map(Number), total = hours * 60 + minutes;
            if (Number.isSafeInteger(total)) return total;
        }
        if (/^\d+(\.\d+)?$/.test(value)) {
            const minutes = Number(value) * 60;
            if (Number.isSafeInteger(Math.round(minutes)) && Math.abs(minutes - Math.round(minutes)) < 0.000001) return Math.round(minutes);
        }
        throw Error('Укажите целые часы и минуты от 0 до 59 в обоих полях.');
    }
    if (!/^\d+(\.\d{1,3})?$/.test(value) || Number(value) > 1000) throw Error('Укажите неотрицательное число дней с точностью до 0,001.');
    return Number(value);
}
module.exports = {keyOf, unitOf, legacy, effective, minutesText, parseQuantity};
